import { render, staticRenderFns } from "./VaultDocuments.vue?vue&type=template&id=33e5b398&lang=pug"
import script from "./VaultDocuments.vue?vue&type=script&lang=js"
export * from "./VaultDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports